<template>
  <Navbar :title="'VIP会员'" :rightBtn="true"></Navbar>
  <div class="content">
    <img class="img" src="@/assets/images/pay/bg_1@2x.png" mode="widthFix" />
    <div class="header">
      <div class="avatar-box flex small">
        <div class="flex-avatar">
          <div class="avatar-img-b">
            <img class="avatar-img" :src="userInfo.avatar" alt="" v-if="userInfo && userInfo.avatar" />
            <img class="avatar-img" src="@/assets/images/avatar.jpg" alt="" v-else />
          </div>
          <img class="vip-img" src="@/assets/images/pay/icon_vip_1@2x.png" alt="" v-if="isVip" />
          <img class="vip-img" src="@/assets/images/pay/icon_vip_2@2x.png" alt="" v-else />
        </div>
        <div class="flex-item flex user-info">
          <div class="flex-item">
            <div class="title_1" v-if="userInfo.company && userInfo.company.name">{{ userInfo.company.name }}</div>
            <div class="name">会员状态<span :class="{ 'active': isVip }">{{ isVip ? '已激活' : '待激活' }}</span></div>
            <div class="vip_txt" v-if="isVip">有效期至：{{ userInfo.expiration_time }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="box" style="padding-bottom:30px;">
      <div :key="item" v-for="item in imgHeader">
        <div class="pic-list-h">
          <img v-lazy="item" class="pic Action" mode="widthFix" />
        </div>
      </div>
    </div>
    <!-- <div class="box">
      <div :key="item" v-for="item in img">
        <div class="pic-list">
          <img v-lazy="item" class="pic Action" mode="widthFix" />
        </div>
      </div>
    </div> -->
    <div class="box" style="padding-bottom: 200rpx;">
      <div :key="item" v-for="item in imgAgree">
        <div class="pic-list">
          <img v-lazy="item" class="pic Action" mode="widthFix" />
        </div>
      </div>
    </div>
    <!-- <div class="float-action-v">
      <div class="flex-item flex price-box">
        <div class="flex-item" v-if="salesmanFlag && isVip">
          <div class="price-txt">服务商特权价:<span class="color_red">360</span>元/年</div>
          <div class="price-txt-2">
            <span>原价:720元/年</span>已优惠￥360元
          </div>
        </div>
        <div class="flex-item" v-if="!salesmanFlag && !isVip">
          <div class="price-txt"><span class="color_red">720</span>元/年</div>
        </div>
      </div>
      <div class="flex-item" @click="submitPay">
        <button class="btn-v" type="primary" v-if="isVip">
          立即续费
        </button>
        <button class="btn-v" type="primary" wx:else>
          立即购买
        </button>
      </div>
    </div> -->

    <!--<div class="float-action-v">-->
      <!--<div class="flex-item flex price-box">-->
        <!--&lt;!&ndash; <div class="flex-item">-->
          <!--<div class="price-txt" style="margin-bottom: 5px;">限时特惠价:<span class="color_red">360</span>元/年-->
          <!--</div>-->
          <!--<div class="price-txt-2">-->
            <!--<span>原价:720元/年</span>已优惠￥360元-->
            <!--<div class="flex-item">-->
            <!--</div>-->
          <!--</div>-->
        <!--</div> &ndash;&gt;-->
        <!--<div class="flex-item">-->
          <!--<div class="price-txt" style="margin-bottom: 5px;">只需<span class="color_red">19.9</span>元/年-->
          <!--</div>-->
          <!--<div class="price-txt-2">-->
            <!--即可畅享VIP会员功能-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
      <!--<div class="btn-v-b" @click="submitPay" v-if="isVip">-->
        <!--<button class="btn-v" type="primary">-->
          <!--立即续费-->
        <!--</button>-->
      <!--</div>-->
      <!--<div class="btn-v-b" @click="submitPay" v-if="!isVip">-->
        <!--<button class="btn-v" type="primary">-->
          <!--立即购买-->
        <!--</button>-->
      <!--</div>-->
    <!--</div>-->
  </div>
  <!-- <div class="float-action-v" v-if="!salesmanFlag">
    <div class="flex-item flex price-box">
      <div class="flex-item">
        <div class="price-txt" style="margin-bottom: 5px;"><span class="color_red">720</span>元/年</div>
        <div class="price-txt-2">
          <span>限时特惠价:360元/年</span>
        </div>
      </div>
    </div>
    <div class="flex-item" @click="submitPay" v-if="isVip">
      <button class="btn-v" type="primary">
        立即续费
      </button>
    </div>
    <div class="flex-item" @click="submitPay" v-if="!isVip">
      <button class="btn-v" type="primary">
        立即购买
      </button>
    </div>
  </div> -->

</template>
<script>
import Navbar from '@/components/Navbar.vue'
import { clickUrl,goCodeFirm } from '@/utils'
import { queryUserById, vipOrderCreateV3 } from '@/api/home'
import icon_h_1 from '@/assets/images/pay/img_1@2x.svg'
import icon_h_2 from '@/assets/images/pay/img_2@2x.svg'
import icon_h_3 from '@/assets/images/pay/img_3@2x.svg'

// import icon_3 from '@/assets/images/pay/img_3@2x.png'
// import icon_4 from '@/assets/images/pay/img_4@2x.png'
// import icon_5 from '@/assets/images/pay/img_5@2x.png'
// import icon_6 from '@/assets/images/pay/img_6@2x.png'
// import icon_7 from '@/assets/images/pay/img_7@2x.png'
// import icon_8 from '@/assets/images/pay/img_8@2x.png'
// import icon_9 from '@/assets/images/pay/img_9@2x.png'
// import icon_10 from '@/assets/images/pay/img_10@2x.png'
// import icon_11 from '@/assets/images/pay/img_11@2x.png'
// import icon_12 from '@/assets/images/pay/img_12@2x.png'

import icon_13 from '@/assets/images/pay/img_13@2x.png'
import icon_14 from '@/assets/images/pay/img_14@2x.png'
import icon_15 from '@/assets/images/pay/img_15@2x.png'
import icon_16 from '@/assets/images/pay/img_16@2x.png'
import icon_17 from '@/assets/images/pay/img_17@2x.png'
import icon_18 from '@/assets/images/pay/img_18@2x.png'
import icon_19 from '@/assets/images/pay/img_19@2x.png'
import icon_20 from '@/assets/images/pay/img_20@2x.png'
import icon_21 from '@/assets/images/pay/img_21@2x.png'

export default {
  components: {
    Navbar
  },
  data() {
    return {
      isVip: false,
      imgHeader:[icon_h_1,icon_h_2,icon_h_3],
      // img: [
      //   icon_3, icon_4, icon_5, icon_6, icon_7,icon_8,icon_9,icon_10, icon_11, icon_12
      // ],
      imgAgree: [
        icon_13, icon_14, icon_15, icon_16, icon_17, icon_18, icon_19, icon_20, icon_21
      ],
      userInfo: {},
      salesmanFlag: false,
      loading: false
    }
  },
  mounted() {
    this.getCompany()
  },
  methods: {
    async getCompany() {
      try {
        let res = await queryUserById()
        this.userInfo = res.result || {}
        this.userId = res.result.id
        this.salesmanFlag = res.result.salesman_id ? true : false
  let e_time = res.result.expiration_time ? res.result.expiration_time.replace(/-/g,'/'):null
        let expirationTime = new Date(e_time).getTime()
        let time = new Date().getTime()
        this.isVip = time < expirationTime ? true : false
      } catch { }
    },
    // submitPay() {
    //   clickUrl('/vip/pay')
    // },
    async submitPay() {
      var that = this
      if (this.loading) {
        return false
      }
      this.loading = true
      if (goCodeFirm(this.userInfo)) {
        this.loading = false
        return false
      }
      let params = {
        company_name: this.userInfo.company ? this.userInfo.company.name : '',
      }
      try {
        let res = await vipOrderCreateV3(params)
        this.wxPayInfo = res.result
        // this.checkXcx()
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
            document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
          }
        } else {
          this.onBridgeReady(res.result);
        }
      } catch {
        that.$toast({ message: '支付没有成功，请重新支付', duration: 3000 })
      } finally {
        this.loading = false
      }

    },
    checkXcx() {
      var u = navigator.userAgent
      if (u.indexOf('miniProgram') !== -1) {//在小程序里
        return false
      }
      // 在微信网页
      this.$router.replace({ path: '/home' })
    },
    onBridgeReady(result) {
      var that = this
      window.WeixinJSBridge.invoke(
        'getBrandWCPayRequest', result || this.wxPayInfo,
        function (res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            sessionStorage.removeItem('matchList')
            that.$dialog.alert({message:"支付成功,稍后会有客服联系您！"}).then(()=>{
              that.$router.replace({ path: '/home' })
            })
          }else{     // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
            this.$toast({ message: '支付没有成功，请重新支付', duration: 3000 })
          }
        }
      );
    },
  }
}
</script>
<style lang="scss" scoped>
.content {
  background: #f3f3f3;
  padding: 0 0 60px;
  position: relative;
}

.pic-list {
  width: 100%;
  margin: 3vw 0;
}

.pic {
  width: 100%;
  display: block;
  opacity: 0;
  transition: opacity 0.3s linear 0.3s;
}

.Action {
  opacity: 1;
}

.box {
  margin: 0;
  z-index: 5;
  position: relative;
  background: transparent;
  padding-bottom: 45px;
}


.policy-detail {
  position: relative;
  padding: 13px;
}

.img {
  width: 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: -46px;
  z-index: 1;
}

.header {
  position: relative;
  z-index: 1;
  padding-top: 1px;
  margin-bottom: 30px;
}

.header .title {
  height: 80px;
  font-size: 16px;
  margin-top: 30px;
  font-weight: bold;
  box-sizing: border-box;
  padding: 0 16px;
  color: #fff;
  display: flex;
  align-items: center;
  background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0));
}

.header .small {
  padding: 20px;
}

.flex {
  display: flex;
  flex-flow: row;
}

.flex-item {
  flex: 1;
}

.user-info {
  align-items: center;
  margin-left: 10px;
}

.avatar-box {
  margin: 30px 0;
  padding: 0;
}

.flex-avatar {
  width: 73px;
  height: 73px;
  border: 2px solid #FFFFFF;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  /* overflow: hidden; */
}

.avatar-img-b {
  width: 73px;
  height: 73px;
  overflow: hidden;
  border-radius: 50%;
}

.avatar-img {
  width: 100%;
  height: 100%;
  background-size: contain;
}

.vip-img {
  width: 51px;
  height: 27px;
  background-size: 100% 100%;
  position: absolute;
  top: -25px;
  left: 11px;
  z-index: 3;
}


.title_1 {
  font-size: 18px;
  font-family: 'PingFang SC-Semibold, PingFang SC';
  font-weight: 600;
  line-height: 21px;
  color: #fff;
  margin-bottom: 10px;
}

.name {
  font-size: 10px;
  color: #fff;
  line-height: 12px;
  //   transform: scale(0.83);
}

.name span {
  background: linear-gradient(180deg, #F6F6F6 0%, #ADADAD 100%);
  border-radius: 8px;
  font-size: 16rpx;
  font-weight: 400;
  color: #6F6F6F;
  line-height: 8px;
  padding: 2px 4px;
}

.name span.active {
  background: linear-gradient(180deg, #FFE0A6 0%, #EA9D3A 100%);
  color: #fff;
}

.float-action-v {
  height: 75px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  background: #fff;
  z-index: 100;
  left: 0;
  bottom: 0;
  right: 0;
  font-size: 12px;
  color: #DFC18D;
  padding: 0 14px 0 15px;
  box-shadow: 0px -4px 8px 1px rgba(157, 151, 132, 0.15);
}

.float-action-v.transparent {
  background: transparent;
}

.btn-v-b{
   width: 145px;
  height: 43px;
}
 .btn-v {
  width: 100%;
  height: 43px;
  font-size: 18px;
  font-weight: 600;
  color: #51432E;
  background: linear-gradient(53deg, #FFDC80 0%, #FEB75B 100%);
  border-radius: 6px;
  border: 0;
}

.price-txt {
  font-size: 14px;
  text-align: left;
}

.color_red {
  font-weight: 600;
  font-size: 29px;
  color: #FF642E;
}

.price-txt-2 {
  font-size: 12px;
  font-family: 'PingFang SC-Light, PingFang SC';
  font-weight: 400;
  color: #B4996C;
  line-height: 12px;
  white-space: nowrap;
  // transform: scale(0.83);
  text-align: left;
}

.price-txt-2 span {
  background: #F6DFBD;
  border-radius: 8px;
  font-weight: 400;
  color: #B4996C;
  padding: 2px 4px;
  margin-right: 5px;
}

.price-box {
  margin-top: -15px;
}

.vip_txt {
  font-size: 10px;
  color: #FFD595;
  margin-top: 3px;
}
</style>
